import styled from 'styled-components/macro'
import MuiAppBar from '@material-ui/core/AppBar'

// eslint-disable-next-line no-unexpected-multiline
const AppBar = styled(MuiAppBar)`
  position: fixed;
`

export default AppBar
